import Table from '@/common/components/Table';
import React, { useMemo } from 'react';
import { Wrapper } from './ConsultantRefundsTable.styles';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { findUserById } from '@/common/functions/findUserById';
import userManager from '@/API/userManager';
import { getRows } from '../../helpers/getRows';
import { CONSULTANT_REFUNDS_TABLE_HEADERS } from '../../constants/tableHeaders';

const ConsultantRefundsTable = ({ hook }) => {
	const {
		commonData: { users },
	} = useCommonDataContext();

	const userId = userManager.getUser().id;
	const consultant = findUserById(userId, users);


	const rows = useMemo(() => {
		if (!hook.data?.length) {
			return [];
		}
		return getRows(hook.data, consultant?.salary_currency, hook.downloadPdf, hook.loadingFiles);
	}, [hook.data, hook.loadingFiles]);

	return (
		<Wrapper>
			<Table className='styled-table' headers={CONSULTANT_REFUNDS_TABLE_HEADERS} raws={rows} />
		</Wrapper>
	);
};

export default ConsultantRefundsTable;
